import React, { FC } from "react"

import AssetService from "services/AssetService"
import Select, { ISelectOption } from "components/Select/Select"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import { SepoCategory, SepoTagType } from "config/constants"

export interface ISelectSupplierOption {
    label: string
    value: string
}

export interface ISelectSupplierOptionProps {
    name?: string
    highlight?: string
}

const SelectSupplierOption: FC<React.PropsWithChildren<ISelectSupplierOptionProps>> = function({
    name,
    highlight,
}) {
    if (!name) {
        return null
    }
    return (
        <FlexibleContent
            text={name}
            highlight={highlight} />
    )
}

export interface ISelectSupplierProps {
    value?: string,
    isInvalid?: boolean
    isInModal?: boolean
    testIdPrefix?: string
    onChange(ownerName?: string): void
}

const SelectSupplier: FC<React.PropsWithChildren<ISelectSupplierProps>> = ({
    value,
    isInvalid,
    isInModal,
    testIdPrefix = "customer-select",
    onChange,
}) => {
    function getSuppliers(search?: string) {
        return AssetService.getSepoTags({
            tagType: SepoTagType.name,
            category: SepoCategory.supplier,
        })
    }

    function getOptionTemplate(option: ISelectSupplierOption, search?: string) {
        return <SelectSupplierOption name={option.label} highlight={search} />
    }

    function handleChange(option?: ISelectOption<string>) {
        onChange(option?.value)
    }

    const defaultValue: ISelectOption<string> | undefined = value ? {
        label: value,
        value,
    } : undefined

    return (
        <Select
            defaultValue={defaultValue}
            onChange={handleChange}
            getOptions={getSuppliers}
            optionTemplate={(option, search) => getOptionTemplate(option, search)}
            isInvalid={isInvalid}
            isInModal={isInModal}
            isClearable
            isCreatable
            testIdPrefix={testIdPrefix}
        />
    )
}

export default SelectSupplier
